import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
    fetchOrthodontistFeatureFlags,
    toggleOrthodontistFeatureFlag
} from '../services/orthodontistFeatureFlags';
import { ORTHODONTIST_FEATURE_FLAGS_KEY } from './queryKeys';

export function useOrthodontistFeatureFlags(orthodontistId: string | undefined) {
    const query = useQuery({
        queryKey: ORTHODONTIST_FEATURE_FLAGS_KEY(orthodontistId ?? ''),
        queryFn: () => fetchOrthodontistFeatureFlags(orthodontistId as string),
        enabled: Boolean(orthodontistId),
        staleTime: 60_000
    });

    return {
        features: query.data ?? [],
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error
    };
}

interface ToggleOrthodontistFeatureFlagArgs {
    feature: string;
    enabled: boolean;
}

export function useToggleOrthodontistFeatureFlag(orthodontistId: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ feature, enabled }: ToggleOrthodontistFeatureFlagArgs) =>
            toggleOrthodontistFeatureFlag(orthodontistId, feature, enabled),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ORTHODONTIST_FEATURE_FLAGS_KEY(orthodontistId)
            });
        }
    });
}
